import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { apiClientV2 } from '~/api/client';
import { ICreatorPlatformStatusValue } from '~/clientApi';
import { SOCIAL_PLATFORM_PIPELINE_STATUS } from '~/clientApi/offPlatform.model';
import { getHasPending } from '~/core/utils';

type Payload = {
  igHandle?: string;
  ttHandle?: string;
  snapHandle?: string;
};

type SearchResponse = {
  success: boolean;
  data: PlatformSearchResult;
};

export interface PlatformSearchResult {
  instagram?: PlatformData;
  tiktok?: PlatformData;
  youtube?: PlatformData;
  snapchat?: PlatformData;
}
export interface PlatformData {
  name: string;
  status: ICreatorPlatformStatusValue;
  followersCount: number;
  profilePictureUrl: string;
  pipelineStatus: SOCIAL_PLATFORM_PIPELINE_STATUS;
  pipelineStatusReason: string;
  handle: string;
  lastUpdatedAt: string;
  platform?: string;
  type?: string;
  id?: string; // used for whalar-mode
  slug?: string; // used for whalar-mode
  isPrimary?: boolean; // used for whalar-mode
}

const ERR_POLL_INCOMPLETE = 'Polling incomplete';

// whalar-mode flow also make use of this hook
// please be aware in case any changes are done
export const useOPCreatorSearch = () => {
  return useMutation<
    PlatformSearchResult,
    string | AxiosError,
    Payload,
    Response
  >(
    (payload: Payload) => {
      return apiClientV2
        .post('/creator-off-platforms-search', { ...payload })
        .then((resp: AxiosResponse<SearchResponse>) => {
          const { data } = resp;
          if (data.data) {
            const hasPending = getHasPending(data.data);
            if (hasPending) throw ERR_POLL_INCOMPLETE;
          }
          return data.data;
        });
    },
    {
      retry: (_, error) => {
        if (error === ERR_POLL_INCOMPLETE) return true;
        return false;
      },
      retryDelay: 3000,
    },
  );
};
